import './components/product/product-media-slider';
import './components/product/product-accordions';
import { wishlistFunctionsPDP } from './components/product/product-wishlist-btn.js';
import { stickySingleProduct } from './components/product/product-sticky-atc.js';
import './components/product/product-modal.js';

stickySingleProduct();
wishlistFunctionsPDP();